//https://reactnavigation.org/docs/configuring-links/#passing-params
//important links: https://reactnavigation.org/blog/2020/05/16/web-support/

import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import NoFoundController from "../common/controllers/NoFoundController";
import routes from "./routes";
import DashboardController from "../dashboard/controllers/DashboardController";
import ExtensionController from "../extensions/controllers/ExtensionController";
import FeatureCodeController from "../common/controllers/FeatureCodeController";
import PinManagementController from "../vvn/controllers/PinManagementController";
import PinHistoryController from "../vvn/controllers/PinHistoryController";
import ReportScheduleController from "../vvn/controllers/ReportScheduleController";
import CallingRateController from "../vvn/controllers/CallingRateController";
import GatewayController from "../extensions/controllers/GatewayController";
import RingGroupController from "../extensions/controllers/RingGroupController";
import NumberController from "../extensions/controllers/NumberController";
import InboundRouteController from "../extensions/controllers/InboundRouteController";
import VoicemailController from "../extensions/controllers/VoicemailController";
import VoicemailMessageController from "../extensions/controllers/VoicemailMessageController";
import HardwareController from "../extensions/controllers/HardwareController";
import IvrController from "../extensions/controllers/IvrController";
import DialplanController from "../extensions/controllers/DialplanController";
import RecordingController from "../extensions/controllers/RecordingController";
import PbxCdrController from "../extensions/controllers/PbxCdrController";
import UserController from "../user/controllers/UserController";
import UserDetailController from "../user/controllers/UserDetailController";
import RegistrationController from "../extensions/controllers/RegistrationController";
import MarketingController from "../marketing/controllers/MarketingController";
import GuestAppController from "../marketing/controllers/GuestAppController";
import CrewAppController from "../marketing/controllers/CrewAppController";
import HospitalityController from "../marketing/controllers/HospitalityController";
import TelehealthController from "../marketing/controllers/TelehealthController";
import ImpactStudyController from "../marketing/controllers/ImpactStudyController";
import ImpactStudiesController from "../marketing/controllers/ImpactStudiesController";
import AboutUsController from "../marketing/controllers/AboutUsController";
import SetupController from "../setup/controllers/SetupController";
import SettingsController from "../settings/controllers/SettingsController";
import PlanController from "../plans/controllers/PlanController";

const Stack = createNativeStackNavigator();

function AppNavigator({ onControllerChanged, initialRoute }) {
  return (
    <Stack.Navigator
      initialRouteName={initialRoute}
      screenListeners={{
        state: (e) => {
          const controller =
            e.data.state.routes[e.data.state.routes.length - 1].name;
          if (onControllerChanged) {
            onControllerChanged(controller);
          }
        },
      }}
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: "#131417" },
      }}
    >
      <Stack.Screen
        name={routes.dashboard}
        component={DashboardController}
        options={{ title: "VOXCRAFT | Dashboard" }}
      />

      <Stack.Screen
        name={routes.setup}
        component={SetupController}
        options={{ title: "Voxcraft | Setup Wizard" }}
      />

      <Stack.Screen
        name={routes.settings}
        component={SettingsController}
        options={{ title: "Voxcraft | Settings" }}
      />

      <Stack.Screen
        name={routes.plan}
        component={PlanController}
        options={{ title: "Voxcraft | Plans" }}
      />

      <Stack.Screen
        name={routes.pinmanagement}
        component={PinManagementController}
        options={{ title: "VOXCRAFT | Pin Management" }}
      />

      <Stack.Screen
        name={routes.pincdr}
        component={PinHistoryController}
        options={{ title: "VOXCRAFT | CDRs" }}
      />

      <Stack.Screen
        name={routes.callingrate}
        component={CallingRateController}
        options={{ title: "VOXCRAFT | Calling Rates" }}
      />

      <Stack.Screen
        name={routes.reportschedule}
        component={ReportScheduleController}
        options={{ title: "VOXCRAFT | Report Schedule" }}
      />

      <Stack.Screen
        name={routes.registration}
        component={RegistrationController}
        options={{ title: "VOXCRAFT | Registrations" }}
      />

      <Stack.Screen
        name={routes.extension}
        component={ExtensionController}
        options={{ title: "VOXCRAFT | Extensions" }}
      />

      <Stack.Screen
        name={routes.inboundroute}
        component={InboundRouteController}
        options={{ title: "VOXCRAFT | Inbound Route" }}
      />

      <Stack.Screen
        name={routes.voicemail}
        component={VoicemailController}
        options={{ title: "VOXCRAFT | Voicemail" }}
      />

      <Stack.Screen
        name={routes.voicemailmessage}
        component={VoicemailMessageController}
        options={{ title: "VOXCRAFT | Messages" }}
      />

      <Stack.Screen
        name={routes.hardware}
        component={HardwareController}
        options={{ title: "VOXCRAFT | Hardware" }}
      />

      <Stack.Screen
        name={routes.ivr}
        component={IvrController}
        options={{ title: "VOXCRAFT | IVR Menus" }}
      />

      <Stack.Screen
        name={routes.dialplan}
        component={DialplanController}
        options={{ title: "VOXCRAFT | Dialplans" }}
      />

      <Stack.Screen
        name={routes.recording}
        component={RecordingController}
        options={{ title: "VOXCRAFT | Recordings" }}
      />

      <Stack.Screen
        name={routes.pbxcdr}
        component={PbxCdrController}
        options={{ title: "VOXCRAFT | PBX CDR" }}
      />

      <Stack.Screen
        name={routes.gateway}
        component={GatewayController}
        options={{ title: "VOXCRAFT | Gateway" }}
      />

      <Stack.Screen
        name={routes.ringgroup}
        component={RingGroupController}
        options={{ title: "VOXCRAFT | Ring Groups" }}
      />

      <Stack.Screen
        name={routes.number}
        component={NumberController}
        options={{ title: "VOXCRAFT | Numbers" }}
      />

      <Stack.Screen
        name={routes.user}
        component={UserController}
        options={{ title: "VOXCRAFT | Users" }}
      />

      <Stack.Screen
        name={routes.userdetails}
        component={UserDetailController}
        options={{ title: "VOXCRAFT | User Details" }}
      />

      <Stack.Screen
        name={routes.featurecode}
        component={FeatureCodeController}
        options={{ title: "VOXCRAFT | Feature Code" }}
      />

      <Stack.Screen
        name={routes.marketing}
        component={MarketingController}
        options={{ title: "VOXCRAFT | Marketing" }}
      />

      <Stack.Screen
        name={routes.health}
        component={TelehealthController}
        options={{ title: "VOXCRAFT | Health" }}
      />

      <Stack.Screen
        name={routes.crewapp}
        component={CrewAppController}
        options={{ title: "VOXCRAFT | Crew App" }}
      />

      <Stack.Screen
        name={routes.guestapp}
        component={GuestAppController}
        options={{ title: "VOXCRAFT | Guest App" }}
      />

      <Stack.Screen
        name={routes.hospitality}
        component={HospitalityController}
        options={{ title: "VOXCRAFT | Hospitality" }}
      />

      <Stack.Screen
        name={routes.impactstudies}
        component={ImpactStudiesController}
        options={{ title: "VOXCRAFT | Impact Studies" }}
      />

      <Stack.Screen
        name={routes.impactstudy}
        component={ImpactStudyController}
        options={{ title: "VOXCRAFT | Impact Study" }}
      />

      <Stack.Screen
        name={routes.aboutus}
        component={AboutUsController}
        options={{ title: "NTCONNECT | About Us" }}
      />

      <Stack.Screen
        name={routes.notfound}
        component={NoFoundController}
        options={{ title: "VOXCRAFT | No Found" }}
      />
    </Stack.Navigator>
  );
}

export default AppNavigator;
